import { actions } from '../../utils/constants';

export const asyncFetchTemplateTests = ({
    page,
    pageSize,
    orderBy,
    orderMode,
    typeTest,
    label,
    status,
}) => ({
    type: actions.ASYNC_FETCH_TEMPLATE_TESTS,
    payload: { page, pageSize, orderBy, orderMode, typeTest, label, status },
});

export const asyncRemoveTemplateTest = ({ testId }) => ({
    type: actions.ASYNC_REMOVE_TEMPLATE_TEST,
    payload: { testId },
});

export const changeModalRemoveTemplateTest = showModal => ({
    type: actions.CHANGE_MODAL_REMOVE_TEMPLATE_TEST,
    payload: showModal,
});

export const changeShouldBeRefreshTemplateTests = shouldBeRefresh => ({
    type: actions.CHANGE_SHOULD_BE_REFRESH_TEMPLATE_TESTS,
    payload: shouldBeRefresh,
});

export const asyncFecthTypeTestsToFilter = () => ({
    type: actions.ASYNC_FETCH_TEST_TYPES_TO_FILTER,
});



// WEBPACK FOOTER //
// ./src/components/tests/tests.actions.js